import {Dau} from "@store/dau"
export default {
   
    computed: {
        _isdebug() {
            return Dau.isdebug();
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixin.js